import {useQuery} from "@tanstack/react-query";
import {subscriptionApiService} from "./subscriptionApi.service.js";

export const subscriptionKeysStore = {
  root: ["subscription"] as const,
  status: (companyId?: string) => [...subscriptionKeysStore.root, "status", companyId] as const,
  paymentStatus: (companyId?: string) =>
    [...subscriptionKeysStore.root, "paymentStatus", companyId] as const,
};

/**
 * Hook to get subscription status
 * 📋 Fetches enablePayment, billingCycleAnchor, and billingCycle for the current company
 */
export function useSubscriptionStatus(companyId?: string) {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: subscriptionKeysStore.status(companyId),
    queryFn: subscriptionApiService.getSubscription,
    enabled: companyId !== undefined,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    subscription: data,
    isSubscriptionLoading: isLoading,
    isSubscriptionFetching: isFetching,
    refetchSubscription: refetch,
  };
}

/**
 * Hook to get detailed payment status — only called when paymentNeeded is true.
 */
export function usePaymentStatus(enabled: boolean, companyId?: string) {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: subscriptionKeysStore.paymentStatus(companyId),
    queryFn: subscriptionApiService.getPaymentStatus,
    enabled: enabled && companyId !== undefined,
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
  });

  return {
    paymentStatus: data,
    isPaymentStatusLoading: isLoading,
    isPaymentStatusFetching: isFetching,
    refetchPaymentStatus: refetch,
  };
}
